import {
  IOderManagementActionBody,
  IOrderManagementFilterBody,
  IOrderManagementStatsFilterBody,
  IPaymentDueCancelOrderBody,
} from "@/api_framework/api_modals/Orders";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useCancelOrderPaymentDueAPI } from "@/app/hooks/api_hooks/orders/useCancelOrderPaymentDueAPI";
import { useOrderManagementOrderListAPI } from "@/app/hooks/api_hooks/orders/useOrderListAPI";
import { useOrderManagementOrderUpdateAPI } from "@/app/hooks/api_hooks/orders/useOrderManagementActionAPI";
import { useOrderManagementReattemptActionAPI } from "@/app/hooks/api_hooks/orders/useOrderManagementReattemptActionAPI";
import { useOrderManagementStatsAPI } from "@/app/hooks/api_hooks/orders/useOrderStatsAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import {
  IOrderManagementState,
  setIsUserPopupModalActive,
} from "@/app_redux/reducers/slices/auth/order_management_slice";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

export interface IRotaFiltersFormFields {
  name?: string;
  cancelreason?: string;
  cancel_reason_name?: string;
}
export interface ActionBodyForProps {
  sub_order_id?: string;
  internal_order_status?: string;
  cancel_reason?: any;
}

export default function QCActionModal({
  buttonName,
  buttonId,
  orders,
  buttonClassName = "",
  hideTrigger = false,
  controlledOpen = undefined,
  onControlledOpenChange = undefined,
}) {
  const [openInternal, setOpenInternal] = useState(false);
  const [checkedArray, setCheckedArray] = useState(orders?.order_details?.sub_order_items?.map(() => false));
  const [editedQuantities, setEditedQuantities] = useState(
    orders?.order_details?.sub_order_items?.map((item) => item?.quantity_to_pick),
  );

  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);
  const [otherCancilation, setOtherCancilation] = useState(false);
  const [otherOptionValue, setOtherOptionValue] = useState(null);
  const dispatch = useDispatch();
  const { manualAssign, cancelResons, orderFilter, orderModule } = routeState.state as IOrderManagementState;

  const manualItem = useSelectMenuReducer(manualAssign, "name", "id");
  const cancelResonsItem = useSelectMenuReducer(cancelResons, "reason_name", "reason_id");

  const updateReattemptAPI = useOrderManagementReattemptActionAPI();
  const { execute: updateOrdersAPI } = useOrderManagementOrderUpdateAPI();
  const { execute: cancelOrderAPI } = useCancelOrderPaymentDueAPI();

  const fetchOrderListAPI = useOrderManagementOrderListAPI();
  const fetchStatsAPI = useOrderManagementStatsAPI();

  const open = controlledOpen ?? openInternal;

  const setModalOpen = (nextOpen: boolean) => {
    if (typeof controlledOpen === "undefined") {
      setOpenInternal(nextOpen);
    }
    onControlledOpenChange?.(nextOpen);
  };

  const handleOpen = () => {
    setModalOpen(true);
  };

  useEffect(() => {
    if (open) {
      dispatch(setIsUserPopupModalActive(true));
    } else {
      dispatch(setIsUserPopupModalActive(false));
    }
  }, [open]);

  const cancelButtonRef = useRef(null);

  const formHook = useForm<IRotaFiltersFormFields>({
    mode: "onChange",
    defaultValues: {},
  });

  // order return
  const handleCheckboxChange = (index) => {
    const newCheckedArray = [...checkedArray];
    newCheckedArray[index] = !newCheckedArray[index];
    setCheckedArray(newCheckedArray);
  };

  const handleIncrement = (index) => {
    const newEditedQuantities = [...editedQuantities];
    const newValue = newEditedQuantities[index] + 1;
    if (newValue <= orders?.order_details?.sub_order_items[index]?.quantity_to_pick) {
      newEditedQuantities[index] = newValue;
      setEditedQuantities(newEditedQuantities);
    }
    const newCheckedArray = [...checkedArray];
    newCheckedArray[index] = true;
    setCheckedArray(newCheckedArray);
  };

  const handleDecrement = (index) => {
    const newEditedQuantities = [...editedQuantities];
    const newValue = newEditedQuantities[index] - 1;
    if (newValue > 0) {
      newEditedQuantities[index] = newValue;
      setEditedQuantities(newEditedQuantities);
      const newCheckedArray = [...checkedArray];
      newCheckedArray[index] = true;
      setCheckedArray(newCheckedArray);
    } else if (newValue === 0) {
      newEditedQuantities[index] = newValue;
      setEditedQuantities(newEditedQuantities);
      const newCheckedArray = [...checkedArray];
      newCheckedArray[index] = false;
      setCheckedArray(newCheckedArray);
    }
  };

  useEffect(() => {
    const cancilation = formHook.watch("cancel_reason_name");

    if (cancilation === "Other") {
      setOtherCancilation(true);
    } else {
      setOtherCancilation(false);
    }
  }, [formHook.watch("cancel_reason_name")]);

  const handelOperationButton = (MODALSOURCE) => {
    const from_data = formHook.getValues();

    if (MODALSOURCE === "MANUALY") {
      const constructedBody: IOderManagementActionBody = {
        sub_order_id: orders?.order_details?.sub_order_id,
        internal_order_status: "delivered_offline",
      };
      const statsBody: IOrderManagementStatsFilterBody = {
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        clinic_id: orderFilter?.clinic_id?.split(","),
      };
      const requestBody: IOrderManagementFilterBody = {
        clinic_id: orderFilter?.clinic_id?.split(","),
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        order_status: "",
        source: orderModule,
        // ...(orderSource && { order_source: orderSource }),
        // page_number: page,
        // page_size: 20,
        // ...(isCentralRole && { for_central: "true" }),
      };
      updateOrdersAPI(constructedBody).then(({ status }) => {
        if (status) {
          (fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody), setModalOpen(false));
        }
      });
    } else if (MODALSOURCE === "CANCEL") {
      const constructedBody: IOderManagementActionBody = {
        sub_order_id: orders?.order_details?.sub_order_id,
        internal_order_status: "cancelled",
        cancel_reason: {
          reason_id: from_data.cancelreason,
          reason_name: from_data.cancel_reason_name === "Other" ? otherOptionValue : null,
        },
      };
      const statsBody: IOrderManagementStatsFilterBody = {
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        clinic_id: orderFilter?.clinic_id?.split(","),
      };
      const requestBody: IOrderManagementFilterBody = {
        clinic_id: orderFilter?.clinic_id?.split(","),
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        order_status: "",
        source: orderModule,
        // ...(orderSource && { order_source: orderSource }),
        // page_number: page,
        // page_size: 20,
        // ...(isCentralRole && { for_central: "true" }),
      };

      updateOrdersAPI(constructedBody).then(({ status }) => {
        if (status) {
          (fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody), setModalOpen(false));
        }
      });
    } else if (MODALSOURCE === "CANCEL_ORDER") {
      const constructedBody: IPaymentDueCancelOrderBody = {
        order_id: orders?.order_details?.order_id,
        source: "portal",
        cancel_reason: {
          reason_id: from_data.cancelreason,
          reason_name: from_data.cancel_reason_name === "Other" ? otherOptionValue : null,
        },
      };
      const statsBody: IOrderManagementStatsFilterBody = {
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        clinic_id: orderFilter?.clinic_id?.split(","),
      };
      const requestBody: IOrderManagementFilterBody = {
        clinic_id: orderFilter?.clinic_id?.split(","),
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        order_status: "",
        source: orderModule,
        // ...(orderSource && { order_source: orderSource }),
        // page_number: page,
        // page_size: 20,
        // ...(isCentralRole && { for_central: "true" }),
      };
      cancelOrderAPI(constructedBody).then(({ status }) => {
        if (status) {
          (fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody), setModalOpen(false));
        }
      });
    } else if (MODALSOURCE === "REATTEMPT") {
      const constructedBody: IOderManagementActionBody = {
        sub_order_id: orders?.order_details?.sub_order_id,
      };
      const statsBody: IOrderManagementStatsFilterBody = {
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        clinic_id: orderFilter?.clinic_id?.split(","),
      };
      const requestBody: IOrderManagementFilterBody = {
        clinic_id: orderFilter?.clinic_id?.split(","),
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        order_status: "",
        source: orderModule,
        // ...(orderSource && { order_source: orderSource }),
        // page_number: page,
        // page_size: 20,
        // ...(isCentralRole && { for_central: "true" }),
      };
      // this api is deffrent
      updateReattemptAPI(constructedBody).then(async () => {
        await Promise.all([fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody)]);
        setModalOpen(false);
      });
    } else if (MODALSOURCE === "RETURN") {
      const constructedBody: IOderManagementActionBody = {
        sub_order_id: orders?.order_details?.sub_order_id,
        internal_order_status: "return_initiated",
      };
      const statsBody: IOrderManagementStatsFilterBody = {
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        clinic_id: orderFilter?.clinic_id?.split(","),
      };
      const requestBody: IOrderManagementFilterBody = {
        clinic_id: orderFilter?.clinic_id?.split(","),
        start_date: orderFilter?.start_date,
        end_date: orderFilter?.end_date,
        order_status: "",
        source: orderModule,
        // ...(orderSource && { order_source: orderSource }),
        // page_number: page,
        // page_size: 20,
        // ...(isCentralRole && { for_central: "true" }),
      };
      updateOrdersAPI(constructedBody).then(({ status }) => {
        if (status) {
          (fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody), setModalOpen(false));
        }
      });
    }
  };

  return (
    <div>
      {!hideTrigger && (
        <button
          onClick={handleOpen}
          className={
            buttonClassName ||
            "w-full rounded-lg bg-black px-2 py-2 text-xs font-medium text-white transition-opacity hover:opacity-90"
          }
        >
          {buttonName}
        </button>
      )}

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={setModalOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform overflow-visible rounded-xl bg-white p-5 text-left shadow-2xl transition-all sm:my-4 
                ${buttonId === "MANUALY" && "sm:max-w-md"}
                ${buttonId === "REATTEMPT" && "sm:max-w-md"}
                ${buttonId === "RETURN" && "sm:max-w-3xl"}
                ${buttonId === "CANCEL" && "sm:max-w-3xl"}
                ${buttonId === "CANCEL_ORDER" && "sm:max-w-3xl"}
                sm:w-full sm:p-6`}
                >
                  {buttonId === "MANUALY" && (
                    <div>
                      <h3 className="text-base font-semibold text-black">
                        Manually Manage Delivery <span className="text-red-500">*</span>
                      </h3>
                      <p className="mt-1 text-sm text-gray-600">Select a delivery status before proceeding.</p>
                      <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3">
                        <p className="text-xs font-medium text-gray-700">Delivery Status</p>
                        <SearchableSelectMenu
                          errorMessages={[{ message: "Name is required", type: "required" }]}
                          onSelectItem={(item) => {
                            if (item) {
                              formHook.setValue("name", item.title);
                            }
                          }}
                          fieldError={formHook.formState.errors.name}
                          register={formHook.register("name", { required: true })}
                          selectItems={manualItem}
                          placeholder="Select status"
                          showTooltips={true}
                          showTypedErrors={true}
                          showDropdownIcon={true}
                          defaultSelected={manualItem?.filter((oc) => oc.id === formHook.watch("name"))[0]}
                          listBoxClassName="w-full"
                          className="text-gray-800 mt-2"
                          containerClassName="w-full mt-2"
                        />
                      </div>
                      <div className="mt-5 flex justify-end gap-3">
                        <button
                          className="rounded-lg bg-[#F1F1F1] px-4 py-2 text-xs font-medium text-[#111827] transition-colors hover:bg-[#E5E7EB]"
                          onClick={() => setModalOpen(false)}
                        >
                          Go Back
                        </button>
                        <button
                          className="rounded-lg bg-black px-4 py-2 text-xs font-medium text-white transition-opacity hover:opacity-90"
                          onClick={() => handelOperationButton(buttonId)}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}
                  {buttonId === "CANCEL" && (
                    <div>
                      <h2 className="text-base font-semibold text-black">Cancel Order</h2>
                      <p className="mt-1 text-sm text-gray-600">Please review items and select a cancellation reason.</p>
                      <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3">
                        <p className="text-xs font-medium text-gray-700">Order Items</p>
                        <div className="mt-2 max-h-[240px] space-y-2 overflow-y-auto pr-1">
                          {orders?.order_details?.sub_order_items?.map((item, index) => {
                            return (
                              <div className="grid grid-cols-6 items-center rounded-md bg-white px-2 py-2 text-sm" key={index}>
                                <div className="col-span-4 flex items-center gap-1">
                                  <span className="text-gray-500">{index + 1}.</span>
                                  <span className="line-clamp-1">{item?.item_name}</span>
                                </div>
                                <p className="col-span-1 text-gray-700">₹ {item?.price}</p>
                                <p className="col-span-1 text-gray-700">{item?.quantity_to_pick} Qty</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <h4 className="mt-4 text-sm font-medium text-gray-700">Reason for cancellation</h4>
                      <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-center">
                        <SearchableSelectMenu
                          errorMessages={[{ message: "Name is required", type: "required" }]}
                          onSelectItem={(item) => {
                            if (item) {
                              formHook.setValue("cancel_reason_name", item.title);
                              formHook.setValue("cancelreason", item.id);
                            }
                          }}
                          fieldError={formHook.formState.errors.cancelreason}
                          register={formHook.register("cancelreason", { required: true })}
                          selectItems={cancelResonsItem}
                          placeholder="Select items"
                          showTooltips={true}
                          showTypedErrors={true}
                          showDropdownIcon={true}
                          defaultSelected={
                            cancelResonsItem?.filter((oc) => oc.id === formHook.watch("cancelreason"))[0]
                          }
                          listBoxClassName="w-full"
                          className="text-gray-800"
                          containerClassName="w-full sm:w-1/2"
                        />
                        {otherCancilation && (
                          <input
                            type="text"
                            value={otherOptionValue}
                            placeholder="Please enter the reason"
                            onChange={(e) => setOtherOptionValue(e.target.value)}
                            className="w-full rounded-lg border border-gray-200 p-2 text-sm sm:w-1/2"
                          />
                        )}
                      </div>
                      <div className="mt-5 flex justify-end gap-3">
                        <button
                          className="rounded-lg bg-[#F1F1F1] px-4 py-2 text-xs font-medium text-[#111827] transition-colors hover:bg-[#E5E7EB]"
                          onClick={() => setModalOpen(false)}
                        >
                          No
                        </button>
                        <button
                          className="rounded-lg bg-black px-4 py-2 text-xs font-medium text-white transition-opacity hover:opacity-90"
                          onClick={() => handelOperationButton(buttonId)}
                        >
                          Yes, Cancel Order
                        </button>
                      </div>
                    </div>
                  )}
                  {buttonId === "CANCEL_ORDER" && (
                    <div>
                      <h2 className="text-base font-semibold text-black">Cancel Order</h2>
                      <p className="mt-1 text-sm text-gray-600">Please review items and select a cancellation reason.</p>
                      <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3">
                        <p className="text-xs font-medium text-gray-700">Order Items</p>
                        <div className="mt-2 max-h-[240px] space-y-2 overflow-y-auto pr-1">
                          {orders?.order_details?.sub_order_items?.map((item, index) => {
                            return (
                              <div className="grid grid-cols-6 items-center rounded-md bg-white px-2 py-2 text-sm" key={index}>
                                <div className="col-span-4 flex items-center gap-1">
                                  <span className="text-gray-500">{index + 1}.</span>
                                  <span className="line-clamp-1">{item?.item_name}</span>
                                </div>
                                <p className="col-span-1 text-gray-700">₹ {item?.price}</p>
                                <p className="col-span-1 text-gray-700">{item?.quantity_to_pick} Qty</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <h4 className="mt-4 text-sm font-medium text-gray-700">Reason for cancellation</h4>
                      <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-center">
                        <SearchableSelectMenu
                          errorMessages={[{ message: "Name is required", type: "required" }]}
                          onSelectItem={(item) => {
                            if (item) {
                              formHook.setValue("cancel_reason_name", item.title);
                              formHook.setValue("cancelreason", item.id);
                            }
                          }}
                          fieldError={formHook.formState.errors.cancelreason}
                          register={formHook.register("cancelreason", { required: true })}
                          selectItems={cancelResonsItem}
                          placeholder="Select items"
                          showTooltips={true}
                          showTypedErrors={true}
                          showDropdownIcon={true}
                          defaultSelected={
                            cancelResonsItem?.filter((oc) => oc.id === formHook.watch("cancelreason"))[0]
                          }
                          listBoxClassName="w-full"
                          className="text-gray-800"
                          containerClassName="w-full sm:w-1/2"
                        />
                        {otherCancilation && (
                          <input
                            type="text"
                            value={otherOptionValue}
                            placeholder="Please enter the reason"
                            onChange={(e) => setOtherOptionValue(e.target.value)}
                            className="w-full rounded-lg border border-gray-200 p-2 text-sm sm:w-1/2"
                          />
                        )}
                      </div>
                      <div className="mt-5 flex justify-end gap-3">
                        <button
                          className="rounded-lg bg-[#F1F1F1] px-4 py-2 text-xs font-medium text-[#111827] transition-colors hover:bg-[#E5E7EB]"
                          onClick={() => setModalOpen(false)}
                        >
                          No
                        </button>
                        <button
                          className="rounded-lg bg-black px-4 py-2 text-xs font-medium text-white transition-opacity hover:opacity-90"
                          onClick={() => handelOperationButton(buttonId)}
                        >
                          Yes, Cancel Order
                        </button>
                      </div>
                    </div>
                  )}
                  {buttonId === "REATTEMPT" && (
                    <div>
                      <h3 className="font-semibold text-black mb-2">
                        Are you sure? <span className="text-red-500">*</span>
                      </h3>
                      <div className="flex items-center gap-3 mt-5">
                        <button
                          className="bg-[#808DA0] text-white p-2 rounded-md text-xs w-full cursor-pointer"
                          onClick={() => setModalOpen(false)}
                        >
                          Go Back
                        </button>
                        <button
                          className="bg-blue-900 text-white p-2 rounded-md text-xs w-full cursor-pointer"
                          onClick={() => handelOperationButton(buttonId)}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}
                  {buttonId === "RETURN" && (
                    <div className="">
                      <div className="flex-col mx-3 my-3 gap-3 flex">
                        <span className="text-black text-base font-medium">Returned Items</span>
                        <table className="mt-1.5">
                          <tbody>
                            {orders?.order_details?.sub_order_items?.map((item, index) => (
                              <tr key={item.index} className="pb-2">
                                <div className="flex gap-[10px]">
                                  <td>
                                    <input
                                      className="h-4 w-4 rounded-sm border-gray-300 text-black focus:ring-0"
                                      type="checkbox"
                                      id={`checkbox-${item.index}`}
                                      name={`checkbox-${item.index}`}
                                      checked={checkedArray[index]}
                                      disabled={editedQuantities[index] === 0}
                                      onChange={() => handleCheckboxChange(index)}
                                    />
                                  </td>
                                  <td className="w-10/12">
                                    <p className="text-sm">{item?.item_name}</p>
                                  </td>
                                </div>
                                <td>
                                  <p className=" text-sm pr-2 ">{item?.price}</p>
                                </td>
                                <td className="flex items-center pb-2 ">
                                  <button
                                    className={`px-2 border border-solid border-black rounded-md ${editedQuantities[index] < 1
                                        ? "bg-gray-300 text-gray-500 cursor-not-allowed border-gray-500"
                                        : ""
                                      }`}
                                    onClick={() => handleDecrement(index)}
                                    disabled={editedQuantities[index] === 0}
                                  >
                                    -
                                  </button>
                                  <span className="mx-4 w-[50px] text-sm">{editedQuantities[index]} Qty</span>
                                  <button
                                    className="px-2 border border-solid border-black rounded-md"
                                    onClick={() => handleIncrement(index)}
                                    disabled={
                                      editedQuantities[index] ===
                                      orders?.order_details?.sub_order_items[index]?.quantity_to_pick
                                    }
                                  >
                                    +
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="flex items-center gap-3 mt-2 float-right w-1/3">
                        <button
                          className="bg-[#808DA0] text-white p-2 rounded-md text-xs  cursor-pointer w-full"
                          onClick={() => setModalOpen(false)}
                        >
                          Go Back
                        </button>
                        <button
                          className="bg-blue-900 text-white p-2 rounded-md text-xs w-full cursor-pointer"
                          onClick={() => handelOperationButton(buttonId)}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
